import { useAppSelector } from "state/hooks.ts";
import { getDepositFundsModalState } from "state/slices/deposit-funds-modal-v2-slice.ts";
import { getBankAccountsState } from "state/slices/bank-accounts-slice.ts";
import { getPaymentMethodsState } from "state/slices/user-payment-methods-slice.ts";
import PaymentNote from "./payment-note.tsx";

const DepositNote = () => {
  const modalState = useAppSelector(getDepositFundsModalState);
  const bankAccountsState = useAppSelector(getBankAccountsState);
  const paymentMethodsState = useAppSelector(getPaymentMethodsState);

  const { processing, selectedPaymentMethod } = modalState;

  // Transform selected payment method for the generic PaymentNote component
  const transformedPaymentMethod = selectedPaymentMethod ? {
    type: selectedPaymentMethod.type,
    bankAccountId: selectedPaymentMethod.type === 'ACH' ? selectedPaymentMethod.bankAccountId : undefined,
    inovioUserPaymentMethodId: selectedPaymentMethod.type === 'CARD' ? selectedPaymentMethod.inovioUserPaymentMethodId : undefined,
    bankName: selectedPaymentMethod.type === 'ACH' ? 
      bankAccountsState.accounts.find(s => s.id === selectedPaymentMethod.bankAccountId)?.bankName : 
      undefined,
    last4: selectedPaymentMethod.type === 'ACH' ? 
      bankAccountsState.accounts.find(s => s.id === selectedPaymentMethod.bankAccountId)?.last4 :
      selectedPaymentMethod.type === 'CARD' && selectedPaymentMethod.inovioUserPaymentMethodId !== 'NEW' ?
        paymentMethodsState.items.find(m => m.id === selectedPaymentMethod.inovioUserPaymentMethodId)?.last4 :
        undefined
  } : undefined;

  // Only render if transformedPaymentMethod is ACH or CARD
  if (!transformedPaymentMethod || (transformedPaymentMethod.type !== 'ACH' && transformedPaymentMethod.type !== 'CARD')) {
    return null;
  }

  return (
    <PaymentNote
      processing={processing}
      paymentMethod={transformedPaymentMethod as { type: 'ACH' | 'CARD'; bankAccountId?: string; inovioUserPaymentMethodId?: string; bankName?: string; last4?: string; }}
      actionType="deposit"
    />
  );
};

export default DepositNote; 